import "shared/globals"
import Vue from 'vue'
import vuetify from '../plugins/vuetify.js'
import MessageFileLightbox from '../message-file-lightbox.vue'
import Vuex from 'vuex'
import axios from "axios"
import VueAxios from "vue-axios"
import TurbolinksAdapter from 'vue-turbolinks'

Vue.use(Vuex)
Vue.use(TurbolinksAdapter)
try { Vue.use(VueAxios, axios) } catch(e) {}

let store = new Vuex.Store({
  state:{
    file: null,
    isPreview: false
  },
  mutations: {
    closePreview(state, data) {
      state.isPreview = data
      state.file = null
    }
  }
})

$( document ).ready(function() {
  $('#messaging-thread').on( "click", ".attachment", function() {
    return Vue.axios
    .get(`/messages/${this.dataset.id}/files/${this.dataset.fileid}`)
    .then(response => {
      store.state.id = this.dataset.id
      store.state.fileId = this.dataset.fileid
      store.state.file = response.data
      store.state.isPreview = true
    });
  });

  Vue.axios.defaults.headers.common["X-CSRF-TOKEN"] = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
  Vue.axios.defaults.headers.common["Accept"] = "application/json";
  var element = document.querySelector("#message-file-lightbox")

  if (element != undefined) {
    const app = new Vue({
      el: element,
      store: store,
      template: "<MessageFileLightbox />",
      components: { MessageFileLightbox },
      vuetify
    })

    app.$mount(element);
  }
})
